var _radialGradient, _path, _path2, _linearGradient, _path3, _linearGradient2, _path4, _linearGradient3, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoodleOriginal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 532.855,
    cy: -537.557,
    r: 209.76,
    gradientTransform: "matrix(1 0 0 -1 -297.6 -460.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FAAF40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#F9A538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.112,
    stopColor: "#F89D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#F89A2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#F7922D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37B28"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M106.259 105.754V66.975c0-8.164-3.397-12.244-10.034-12.244-6.629 0-10.034 4.08-10.034 12.244v38.779H66.294V66.975c0-8.164-3.228-12.244-9.862-12.244-6.633 0-10.036 4.08-10.036 12.244v38.779H26.667V64.768c0-8.504 2.891-14.801 8.844-19.223 5.102-3.91 12.246-5.777 20.92-5.777 9.015 0 15.478 2.207 19.727 6.801 3.57-4.594 10.207-6.801 19.897-6.801 8.844 0 15.819 1.867 20.922 5.777 5.951 4.422 8.843 10.719 8.843 19.223v41.152h-19.563v-.166z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#58595B",
    d: "M28.539 49.627l-2.041 10.207c18.708 6.291 36.395.166 45.751-16.158-13.778-9.522-26.535.17-43.71 5.951"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 324.268,
    y1: -509.952,
    x2: 368.932,
    y2: -509.952,
    gradientTransform: "matrix(1 0 0 -1 -297.6 -460.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#929497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124,
    stopColor: "#757578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    stopColor: "#575658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#403E3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#302D2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#262223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M28.539 47.08c-.681 3.91-1.192 7.65-1.872 11.563 17.857 6.125 35.375.85 44.73-15.137-11.909-13.776-25.17-2.383-42.858 3.574"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 332.834,
    y1: -495.051,
    x2: 351.377,
    y2: -521.534,
    gradientTransform: "matrix(1 0 0 -1 -297.6 -460.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20",
    stopOpacity: 0
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M49.799 51.668c-8.164-1.701-17.009 2.555-23.131 6.975-3.912-28.57 13.777-27.893 36.903-20.75-1.529 6.975-4.083 16.33-8.502 21.941-.169-3.744-1.869-6.293-5.27-8.166"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 299.778,
    y1: -495.802,
    x2: 381.412,
    y2: -495.802,
    gradientTransform: "matrix(1 0 0 -1 -297.6 -460.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#929497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124,
    stopColor: "#757578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    stopColor: "#575658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#403E3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#302D2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#262223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M2.178 47.08c29.932-18.031 46.77-21.43 81.634-25-40.478 31.969-41.499 25-81.634 25"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4C",
    strokeWidth: 0.5,
    fill: "none",
    d: "M83.812 22.246L51.667 45.545"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    fill: "#231F20",
    d: "M45.545 34.66c.34 3.744-.511-3.572 0 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A8ABAD",
    strokeWidth: 0.5,
    fill: "none",
    d: "M2.178 47.08l49.489-1.535"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F16922",
    strokeWidth: 0.5,
    d: "M42.484 35.002C33.98 37.383 6.09 43.506 5.747 47.08c-.849 6.631-.167 17.176-.167 17.176",
    fill: "none"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F16922",
    d: "M8.131 89.596c-3.063-7.652-6.804-16.158-2.384-26.703C8.64 72.756 8.131 80.24 8.131 89.596"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#6D6E70",
    d: "M41.076 33.844c.708-.25 1.384-.17 1.509.184.126.355-.344.846-1.052 1.096-.709.256-1.384.172-1.51-.184-.127-.352.344-.844 1.053-1.096z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodleOriginal);
export default __webpack_public_path__ + "static/media/MoodleOriginal.cf7b145bf9cabd83bf45413a7f0ce565.svg";
export { ForwardRef as ReactComponent };